// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimLabor from '@deere/cps-it.warranty-model-factory/lib/claim-item-labor';
import FormattedNumberInput from '../../../../shared/components/formatted-number-input';
import KeyValueDropDown from '../claim-fields/key-value-dropdown';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {translate} from '../../../../shared/services/translation-service';

function handleHoursChange(hours) {

    this.onHoursChange(hours);

}

function handleLocationChange(event) {

    this.onLocationChange(event.target.value);

}

function handleTypeChange(event) {

    this.onTypeChange(event.target.value);

}

function handleTechIdChange(event) {

    this.onTechIdChange(event.target.value);

}

function handleLaborCommentsChange(event) {

    this.onLaborCommentsChange(event.target.value);

}

const LaborPanelRowBody = props =>
    <div>
        <section className={`labor-panel-row-body labor-item-${props.labor.lineNumber} ${props.highlightClass}`}>
            <FormattedNumberInput
                allowNegative={false}
                className={'hours'}
                decimalPrecision={2}
                isValidInput={value => value < 100000}
                onValueChange={props::handleHoursChange}
                value={props.labor.laborHours}
            />
            <KeyValueDropDown
                className={'labor-location'}
                list={props.laborLocations}
                onChange={props::handleLocationChange}
                value={props.labor.location.key}
            />
            <KeyValueDropDown
                className={'type'}
                list={props.laborTypes}
                onChange={props::handleTypeChange}
                value={props.labor.laborType.key}
            />
            <input
                className='tech-id'
                onChange={props::handleTechIdChange}
                type='text'
                value={props.labor.techId}
            />
            <input
                className={'labor-comment'}
                maxLength={40}
                onChange={props::handleLaborCommentsChange}
                type='text'
                value={props.labor.spgJobCode}
            />
            <span className={'delete-icon-button'}>
                <button
                    className='icon-trash-can'
                    onClick={props.onDelete}
                />
            </span>
        </section>
        {props.vsrMessage &&
            <span className='vsr-message'>
                {`${props.vsrMessage} (${translate('SAVE_TO_VALIDATE')})`}
            </span>
        }
    </div>;

LaborPanelRowBody.displayName = 'LaborPanelRowBody';
LaborPanelRowBody.propTypes = {
    highlightClass: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    labor: PropTypes.instanceOf(ClaimLabor).isRequired,
    laborLocations: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    laborTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    numberOfLabors: PropTypes.number.isRequired,
    onDelete: PropTypes.func.isRequired,
    onHoursChange: PropTypes.func.isRequired,
    onLaborCommentsChange: PropTypes.func.isRequired,
    onLocationChange: PropTypes.func.isRequired,
    onTechIdChange: PropTypes.func.isRequired,
    onTypeChange: PropTypes.func.isRequired,
    vsrMessage: PropTypes.string
};

export default LaborPanelRowBody;



// WEBPACK FOOTER //
// ./src/claim/shared/components/labors-panel/labors-panel-row-body.js